import React, { useEffect, useState, useRef, useMemo, memo } from "react";
import { useNavigate } from "react-router-dom";
import {
  jakusci,
  left_arrow,
  pool,
  right_arrow,
  tub,
  couple,
  local,
} from "../../assets/imgs";
import { Amenities_list } from "../../screens/redux/api/dummyJson";
import {
  useAmenitiesListMutation,
  useLazyPropertiesViewQuery,
  useNewTotalLocationsListMutation,
  useMinimumAgeMutation,
  useLazyPropertyContentListQuery,
  usePropertyDetailsAddMutation,
  useLazyPropertyImageDeleteQuery,
  useLazyAmenitiesDropQuery,
} from "../../screens/redux/api/api";
import SelectBox from "../SelectBox";
import SelectBoxImg from "../SelectBoxImg";
import JoditEditor from "jodit-react";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton } from "@mui/material";
import { configJodit } from "../../screens/redux/api/Constants";
import { toast } from "react-toastify";
import moment from "moment";
import GoogleMapPages from "../../screens/MapTest/GoogleMaps";

const RejectedDetailsTab = ({ data }) => {
  const navigate = useNavigate();
  const id = data?.data?.id;
  const type = data?.data?.property_type;
  const editor = useRef([]);
  const imgRef = useRef(null);

  // State from PropertyDetails
  const [validation, setValidation] = useState("");
  const [policies, setPolicies] = useState([]);
  const [images, setImages] = useState([]);
  const [availabilities, setAvailabilities] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [amenitiesID, setAmenitiesID] = useState([]);
  const [list, setList] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [area, setArea] = useState([]);
  const [checkIn, setCheckIn] = useState("");
  const [checkOut, setCheckOut] = useState("");
  const [couples, setCouples] = useState();
  const [localId, setLocalId] = useState();
  const [prices, setPrices] = useState([
    {
      mon_price: "0",
      tue_price: "0",
      wed_price: "0",
      thu_price: "0",
      fri_price: "0",
      sat_price: "0",
      sun_price: "0",
      total_persons: "0",
      additional_persons: "0",
      extra_charge_per_person: "0",
    },
  ]);
  const [minAge, setMinAge] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [desc, setDesc] = useState("");
  const [edit, setEdit] = useState(false);
  const [reqOn, setReqOn] = useState("");

  // State from Description
  const [popup, setPopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [optionsDesc, setOptionsDesc] = useState([]);
  const [optionsCancel, setOptionsCancel] = useState([]);
  const [optionsRules, setOptionsRules] = useState([]);
  const [optionsSafety, setOptionsSafety] = useState([]);
  const [draggableImages, setDraggableImages] = useState([]);
  const [draggedItem, setDraggedItem] = useState(null);
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [houseRules, setHouseRules] = useState("");
  const [safetyProperty, setSafetyProperty] = useState("");
  const [additionalPolicies, setAdditionalPolicies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ageList, setAgeList] = useState([]);

  // API Hooks
  const [ViewPropertyApi] = useLazyPropertiesViewQuery();
  const [aminitiesListApi] = useLazyAmenitiesDropQuery();
  // const [aminitiesListApi] = useAmenitiesListMutation();
  const [getCountryListApi] = useNewTotalLocationsListMutation();
  const [minimumAgeListApi] = useMinimumAgeMutation();
  const [propertyContentListApi] = useLazyPropertyContentListQuery();
  const [propertyDetailEditApi] = usePropertyDetailsAddMutation();
  const [propertyImageDelete] = useLazyPropertyImageDeleteQuery();

  // Drag and Drop functions

  const draggedItemRef = useRef(null);

  const handleDragStart = (e, index) => {
    draggedItemRef.current = index;
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault(); // Prevent default to allow drop

    const draggedIndex = draggedItemRef.current;
    if (draggedIndex === null || draggedIndex === index) return;

    setDraggableImages((prevItems) => {
      const newItems = [...prevItems];
      const draggedImage = newItems[draggedIndex];
      newItems.splice(draggedIndex, 1);
      newItems.splice(index, 0, draggedImage);
      draggedItemRef.current = index; // Update reference position
      return newItems;
    });
  };

  const handleDragEnd = () => {
    draggedItemRef.current = null;
  };

  // Handle image selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length + draggableImages.length > 10) {
      toast.error("You can upload a maximum of 10 images");
      return;
    }

    const newFiles = files.filter((file) => {
      return !draggableImages.some(
        (img) => img.image.name === file.name && img.image.size === file.size
      );
    });

    const newImages = newFiles.map((file) => ({
      image: file,
      preview: URL.createObjectURL(file),
      isNew: true,
    }));

    setDraggableImages((prev) => [...prev, ...newImages]);
  };

  const handleImageDelete = (id) => {
    propertyImageDelete(id)
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
        }
      })
      .catch((err) => {
        toast.error(err?.message);
      });
  };

  // Remove image
  const handleRemoveImage = (index) => {
    let imId = draggableImages[0]?.id;
    console.log(imId, "imId");
    handleImageDelete(imId);
    const newImages = [...draggableImages];
    newImages.splice(index, 1);
    setDraggableImages(newImages);
  };

  // Handle price change
  const handlePriceChange = (field, value) => {
    setPrices((prev) => [
      {
        ...prev[0],
        [field]: value,
      },
    ]);
  };

  // Get amenities list
  const getList = () => {
    let formdata = new FormData();
    formdata.append("pagination", 0);
    aminitiesListApi(formdata)
      .unwrap()
      .then((res) => {
        setList(res?.data);
      })
      .catch((err) => {
        console.error("err-ami", err);
      });
  };

  // Handle location change
  const handleLocationChange = (id, type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    formdata.append("parent_id", id);

    getCountryListApi(formdata)
      .unwrap()
      .then((res) => {
        switch (type) {
          case 2: // State
            setStateList(res?.data || []);
            break;
          case 3: // City
            setCityList(res?.data || []);
            break;
          case 4: // Area
            setAreaList(res?.data || []);
            break;
          default:
            break;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Get country list
  const getCountry = (type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    getCountryListApi(formdata)
      .unwrap()
      .then((res) => {
        setCountryList(res?.data || []);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // Get property details
  const getDetails = (id) => {
    ViewPropertyApi(id)
      .unwrap()
      .then((res) => {
        setReqOn(res?.data?.property_details);
        if (res?.data?.property_details?.availabilities) {
          // Check if availabilities is an array
          if (Array.isArray(res.data.property_details.availabilities)) {
            // Transform API data to match component's expected format
            const transformedAvailabilities =
              res.data.property_details.availabilities.map((item) => [
                item.value1 || "", // key
                item.value2 || "", // value
              ]);
            setAvailabilities(transformedAvailabilities);
          } else if (
            typeof res.data.property_details.availabilities === "object"
          ) {
            // Handle case where availabilities might be an object
            const availabilitiesObj = res.data.property_details.availabilities;
            setAvailabilities(Object.entries(availabilitiesObj));
          }
        }
        let amenities_ = [];
        res?.data?.amenities?.map((item) => {
          let obj = { ...item };
          obj.name = item?.amenity?.name;
          obj.id = item?.amenity_id;
          obj.amenity_id = item?.id;
          amenities_.push(obj);
        });
        setAmenities(amenities_);

        setCheckIn(res?.data?.property_details?.check_in);
        setCheckOut(res?.data?.property_details?.check_out);
        setCouples(res?.data?.is_couple_friendly);
        setLocalId(res?.data?.is_local_id_allowed);

        // Set prices
        if (res?.data?.prices?.length > 0) {
          setPrices([
            {
              mon_price: res?.data?.prices[0]?.mon_price || "0",
              tue_price: res?.data?.prices[0]?.tue_price || "0",
              wed_price: res?.data?.prices[0]?.wed_price || "0",
              thu_price: res?.data?.prices[0]?.thu_price || "0",
              fri_price: res?.data?.prices[0]?.fri_price || "0",
              sat_price: res?.data?.prices[0]?.sat_price || "0",
              sun_price: res?.data?.prices[0]?.sun_price || "0",
              total_persons: res?.data?.prices[0]?.total_persons || "0",
              additional_persons:
                res?.data?.prices[0]?.additional_persons || "0",
              extra_charge_per_person:
                res?.data?.prices[0]?.extra_charge_per_person || "0",
            },
          ]);
        }

        setMinAge(res?.data?.age_category_id);

        let temp = [];
        temp.push(res?.data?.country);
        setCountry(temp);

        if (res?.data?.country?.id) {
          handleLocationChange(res?.data?.country?.id, 2);
        }

        let semp = [];
        semp.push(res?.data?.state);
        setState(semp);

        if (res?.data?.state?.id) {
          handleLocationChange(res?.data?.state?.id, 3);
        }

        let cemp = [];
        cemp.push(res?.data?.city);
        setCity(cemp);

        if (res?.data?.city?.id) {
          handleLocationChange(res?.data?.city?.id, 4);
        }

        let aemp = [];
        aemp.push(res?.data?.area);
        setArea(aemp);

        setAddress(res?.data?.address);
        setLatitude(res?.data?.latitude);
        setLongitude(res?.data?.longitude);
        setDesc(res?.data?.property_details?.description);

        setPolicies(res?.data?.policies);
        setImages(res?.data?.images);

        // Set property images with preview URLs
        const propertyImages =
          res?.data?.property_images?.map((img) => ({
            ...img,
            preview: img.image,
            isNew: false,
          })) || [];
        setDraggableImages(propertyImages);

        // Process policies
        if (res?.data?.policies && res?.data?.policies.length > 0) {
          res?.data?.policies.forEach((policy) => {
            switch (policy.policy_name) {
              case "Cancellation Policy":
                setCancellationPolicy(policy.description);
                break;
              case "House Rules":
                setHouseRules(policy.description);
                break;
              case "Safety & Property":
                setSafetyProperty(policy.description);
                break;
              default:
                break;
            }
          });

          const additional = res?.data?.policies
            .filter((_, index) => index >= 3)
            .slice(0, 3)
            .map((policy) => ({
              id: policy.id,
              heading: policy.policy_name,
              content: policy.description,
            }));

          setAdditionalPolicies(additional);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Get age list
  const getAge = (type) => {
    let formdata = new FormData();
    formdata.append("type", type);
    minimumAgeListApi(formdata)
      .unwrap()
      .then((res) => {
        setAgeList(res?.categories);
      })
      .catch((err) => {
        console.log("age_err", err);
      });
  };

  // Get policy list
  const getPolList = () => {
    propertyContentListApi()
      .unwrap()
      .then((res) => {
        const cancel = res?.data?.filter((item) => item?.policy_type === 1);
        setOptionsCancel(cancel || []);
        console.log("cancel", cancel);

        const rules = res?.data?.filter((item) => item?.policy_type === 2);
        setOptionsRules(rules || []);

        const safety = res?.data?.filter((item) => item?.policy_type === 3);
        setOptionsSafety(safety || []);

        const desc = res?.data?.filter((item) => item?.policy_type === 4);
        setOptionsDesc(desc || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Handle image click for popup
  const handleImageClick = (image) => {
    setSelectedImage(image);
    setPopup(true);
  };

  // Handle adding new policy
  const handleAddPolicy = () => {
    if (additionalPolicies.length >= 3) return;

    const newPolicy = {
      id: Date.now(),
      heading: `Policy ${additionalPolicies.length + 1}`,
      content: "",
    };

    setAdditionalPolicies([...additionalPolicies, newPolicy]);
  };

  // Handle removing policy
  const handleRemovePolicy = (index) => {
    const updated = [...additionalPolicies];
    updated.splice(index, 1);
    setAdditionalPolicies(updated);
  };

  const handleAdditionalContentChange = (event, ind, type) => {
    let temp = [...additionalPolicies];
    temp[ind][type] = event;
    setAdditionalPolicies(temp);
  };

  // Handle edit submission
  const handleEdit = async (id) => {
    if (availabilities.length === 0) {
      toast.error("Please add at least one availability period");
      return false;
    }

    // 1. Validate required fields
    if (!desc || desc.trim() === "") {
      toast.error("Description is required");
      return;
    }

    if (!country[0]?.id) {
      toast.error("Country is required");
      return;
    }

    if (!state[0]?.id) {
      toast.error("State is required");
      return;
    }

    if (!city[0]?.id) {
      toast.error("City is required");
      return;
    }

    if (!address || address.trim() === "") {
      toast.error("Address is required");
      return;
    }

    if (!minAge) {
      toast.error("Minimum age category is required");
      return;
    }

    // Validate location coordinates
    if (!latitude || !longitude) {
      toast.error("Please select a valid location on the map");
      return;
    }

    // Validate time fields
    if (!checkIn) {
      toast.error("Check-in time is required");
      return;
    }

    if (!checkOut) {
      toast.error("Check-out time is required");
      return;
    }

    // Validate pricing if not individual type
    if (type !== 1) {
      const requiredPricingFields = [
        "mon_price",
        "tue_price",
        "wed_price",
        "thu_price",
        "fri_price",
        "sat_price",
        "sun_price",
        "total_persons",
      ];

      for (const field of requiredPricingFields) {
        if (!prices[0]?.[field] || prices[0][field] === "0") {
          toast.error(`Please set ${field.replace("_", " ")}`);
          return;
        }
      }
    }

    // Validate at least one amenity is selected
    if (amenities.length === 0) {
      toast.error("Please select at least one amenity");
      return;
    }

    // Validate availabilities
    const validAvailabilities = availabilities.filter(
      ([key, value]) => key.trim() && value.trim()
    );

    if (validAvailabilities.length === 0) {
      toast.error("Please add at least one availability period");
      return;
    }

    // Validate policies
    if (!cancellationPolicy || cancellationPolicy.trim() === "") {
      toast.error("Cancellation policy is required");
      return;
    }

    if (!houseRules || houseRules.trim() === "") {
      toast.error("House rules are required");
      return;
    }

    if (!safetyProperty || safetyProperty.trim() === "") {
      toast.error("Safety & property information is required");
      return;
    }

    // Validate images
    if (draggableImages.length === 0) {
      toast.error("Please upload at least one property image");
      return;
    }

    setLoading(true);

    try {
      // 1. Convert availability array to object format
      const availabilitiesObj = {};
      availabilities.forEach(([key, value]) => {
        if (key.trim() && value.trim()) {
          // Only add if both key and value are non-empty
          availabilitiesObj[key] = value;
        }
      });

      // 2. Prepare FormData
      const formDataToSend = new FormData();
      formDataToSend.append("property_id", id);

      // 3. Append amenities
      amenities.forEach((amenity, index) => {
        formDataToSend.append(`amenity_ids[${index}]`, amenity.id);
      });

      // 4. Append availabilities
      formDataToSend.append(
        "availabilities",
        JSON.stringify(availabilitiesObj)
      );

      // 5. Handle time fields

      if (checkIn) {
        const formattedCheckIn = moment(checkIn, "HH:mm").format("HH:mm");
        formDataToSend.append("check_in", formattedCheckIn);
      }

      if (checkOut) {
        const formattedCheckOut = moment(checkOut, "HH:mm").format("HH:mm");
        formDataToSend.append("check_out", formattedCheckOut);
      }

      // 6. Append other customer option data
      const customerOptions = {
        description: desc,
        country_id: country[0]?.id || "",
        state_id: state[0]?.id || "",
        city_id: city[0]?.id || "",
        area_id: area[0]?.id || "",
        address: address,
        age_category_id: minAge,
        is_couple_friendly: couples ? 1 : 0,
        is_local_id_allowed: localId ? 1 : 0,
        latitude: latitude,
        longitude: longitude,
      };

      // Add pricing if not type 1 (individual)
      if (type !== 1) {
        customerOptions.pricing = {
          mon_price: prices[0]?.mon_price || "0",
          tue_price: prices[0]?.tue_price || "0",
          wed_price: prices[0]?.wed_price || "0",
          thu_price: prices[0]?.thu_price || "0",
          fri_price: prices[0]?.fri_price || "0",
          sat_price: prices[0]?.sat_price || "0",
          sun_price: prices[0]?.sun_price || "0",
          total_persons: prices[0]?.total_persons || "0",
          additional_persons: prices[0]?.additional_persons || "0",
          extra_charge_per_person: prices[0]?.extra_charge_per_person || "0",
        };
      }

      Object.entries(customerOptions).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === "pricing" && typeof value === "object") {
            Object.entries(value).forEach(([pricingKey, pricingValue]) => {
              formDataToSend.append(`pricing[${pricingKey}]`, pricingValue);
            });
          } else {
            formDataToSend.append(key, value);
          }
        }
      });

      // 7. Append description data (policies)
      const policies = [
        {
          policy_name: "Cancellation Policy",
          description: cancellationPolicy,
        },
        {
          policy_name: "House Rules",
          description: houseRules,
        },
        {
          policy_name: "Safety & Property",
          description: safetyProperty,
        },
        ...additionalPolicies
          .filter((item) => item.heading && item.content)
          .map((item, index) => ({
            policy_name: item.heading,
            description: item.content,
          })),
      ].filter((policy) => policy.description);

      policies.forEach((policy, index) => {
        formDataToSend.append(
          `property_policies[${index}][policy_name]`,
          policy.policy_name
        );
        formDataToSend.append(
          `property_policies[${index}][description]`,
          policy.description
        );
      });

      const filePromises = draggableImages.map(async (image, index) => {
        // Add position
        formDataToSend.append(
          `property_images[${index}][position]`,
          (index + 1).toString()
        );

        if (image.isNew && image.image instanceof File) {
          // New image already as File
          formDataToSend.append(
            `property_images[${index}][image]`,
            image.image
          );
        } else {
          // Existing image: fetch and convert to File
          const response = await fetch(image.image);
          const blob = await response.blob();
          const file = new File([blob], `image_${index}.png`, {
            type: blob.type,
          });

          formDataToSend.append(`property_images[${index}][image]`, file);
        }
      });

      await Promise.all(filePromises);

      // 9. Make API call
      const res = await propertyDetailEditApi(formDataToSend).unwrap();

      if (res?.status === "success") {
        toast.success(res?.message);
        // Refresh the data after successful edit
        getDetails(id);
        setEdit(false);
      } else {
        console.warn("API returned non-success status:", res);
      }
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.data?.message || "Failed to update property details");
    } finally {
      setLoading(false);
    }
  };

  // Initialize data
  useEffect(() => {
    if (id) {
      getDetails(id);
    }
    getList();
    getCountry(1);
    getAge(2);
    getPolList();
  }, [id]);

  // Add new availability
  const addAvailability = () => {
    setAvailabilities([...availabilities, ["", ""]]);
  };

  // Remove availability by index
  const removeAvailability = (index) => {
    const newAvailabilities = [...availabilities];
    newAvailabilities.splice(index, 1);
    setAvailabilities(newAvailabilities);
  };

  // Handle availability change
  const handleAvailabilityChange = (index, field, newValue) => {
    const newAvailabilities = [...availabilities];
    if (field === "key") {
      newAvailabilities[index][0] = newValue;
    } else {
      newAvailabilities[index][1] = newValue;
    }
    setAvailabilities(newAvailabilities);
  };

  const houseRulesRef = useRef(null);

  useEffect(() => {
    if (checkIn) {
      const [hours, minutes] = checkIn.split(":").map(Number);
      const checkInDate = new Date();
      checkInDate.setHours(hours);
      checkInDate.setMinutes(minutes);

      // Add 22 hours
      checkInDate.setHours(checkInDate.getHours() + 22);

      const hh = String(checkInDate.getHours()).padStart(2, "0");
      const mm = String(checkInDate.getMinutes()).padStart(2, "0");

      setCheckOut(`${hh}:${mm}`);
    }
  }, [checkIn]);

  const joditConfig = useMemo(
    () => ({
      readonly: !edit,
      ...configJodit,
    }),
    [edit]
  );

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div className="mt-2">
      <div className="d-flex ac-jb">
        <div
          className="d-flex ac-js pointer gap-2"
          onClick={() => navigate(-1)}
        >
          <img src={left_arrow} className="leftArrow mb-3" alt="Back arrow" />
          <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Back
          </p>
        </div>
        <div onClick={() => setEdit(!edit)}>
          {!edit ? (
            <p
              className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
              style={{ cursor: "pointer" }}
            >
              Edit
            </p>
          ) : (
            <p
              className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary cust-btn recep-yes"
              style={{ cursor: "pointer" }}
              onClick={() => getDetails(id)}
            >
              cancel
            </p>
          )}
        </div>
      </div>

      {/* Availability Section */}
      <div className="mb-4">
        <div className="d-flex flex-column">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
            Availability
          </h4>
          {edit && availabilities.length < 4 && (
            <button
              className="cust-btn recep-yes my-3"
              onClick={addAvailability}
            >
              Add
            </button>
          )}
        </div>

        <div className="d-flex flex-wrap gap-5 mb-4">
          {availabilities.map(([key, value], index) => (
            <div key={index} className="col-md-5">
              <div className="d-flex ac-jb gap-3 mb-3">
                <div className="w-40">
                  <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                    Key
                  </h4>
                  <input
                    type="text"
                    className="input-pop ps-2 w-100"
                    value={key}
                    onChange={(e) =>
                      handleAvailabilityChange(index, "key", e.target.value)
                    }
                    disabled={!edit}
                  />
                </div>
                <div className="w-40">
                  <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                    Value
                  </h4>
                  <input
                    type="text"
                    className="input-pop ps-2 w-100"
                    value={value}
                    onChange={(e) =>
                      handleAvailabilityChange(index, "value", e.target.value)
                    }
                    disabled={!edit}
                  />
                </div>
                {edit && (
                  <div className="w-20 d-flex ac-jc">
                    <IconButton
                      onClick={() => removeAvailability(index)}
                      size="small"
                    >
                      <CancelIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Amenities Section */}
      <div className="mb-4">
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
          Amenities
        </h4>

        {edit && (
          <div className="mt-3 mb-4 col-md-5">
            <SelectBoxImg
              array_list={list}
              value_text={amenities}
              setvalue_text={setAmenities}
              value_id={amenitiesID}
              setvalue_id={setAmenitiesID}
              placeholder_text={"Select Amenities"}
              isMulti={true}
              isTextArea={false}
              setValidation={setValidation}
              edit={edit ? false : true}
            />
          </div>
        )}

        <div className="d-flex ac-js ">
          <div className="col-md-12">
            <div className="d-flex  flex-wrap gap-3">
              {amenities.map((amenity, index) => (
                <div
                  key={index}
                  className="d-flex ac-jc gap-1 p-2 input-pop mb-3"
                >
                  <img
                    src={
                      amenity?.amenity?.image_url
                        ? amenity?.amenity?.image_url
                        : amenity?.image_url
                    }
                    alt={
                      amenity?.amenity?.name
                        ? amenity?.amenity?.name
                        : amenity?.name
                    }
                    className="tub-img"
                  />
                  <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                    {amenity?.amenity?.name
                      ? amenity?.amenity?.name
                      : amenity?.name}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Customer Options Section */}
      <div className="mt-3">
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Check In Time
            </h4>
            <input
              type="time"
              className="input-pop ps-2 w-100"
              placeholder=""
              value={checkIn}
              onChange={(e) => setCheckIn(e.target.value)}
              disabled={!edit}
            />
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Check Out TIme
            </h4>
            <input
              type="time"
              className="input-pop ps-2 w-100"
              placeholder=""
              value={checkOut}
              onChange={(e) => setCheckOut(e.target.value)}
              disabled={!edit}
            />
          </div>
        </div>
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
          Customer Option
        </h4>
        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5 d-flex ac-js gap-5">
            <div className="input-pop p-2">
              <button className="d-flex ac-jc gap-3 cust-btn w-100">
                <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary flex-nowrap">
                  Couple Friendly
                </p>
                <img src={couple} alt="" className="tub-img" />
              </button>
            </div>
            <div className="d-flex ac-js gap-3">
              <button
                className={`cust-btn w-100 ${
                  couples === true ? "recep-yes" : "recep-no"
                }`}
                onClick={() => setCouples(!couples)}
                disabled={!edit}
              >
                Yes
              </button>
              <button
                className={`cust-btn w-100 ${
                  couples === false ? "recep-yes" : "recep-no"
                }`}
                onClick={() => setCouples(!couples)}
                disabled={!edit}
              >
                No
              </button>
            </div>
          </div>

          <div className="col-md-5 d-flex ac-js gap-5">
            <div className="input-pop p-2">
              <button className="d-flex ac-jc gap-3 cust-btn w-100">
                <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                  Local ID Allowed
                </p>
                <img src={local} alt="" className="tub-img" />
              </button>
            </div>
            <div className="d-flex ac-js gap-3">
              <button
                className={`cust-btn w-100 ${
                  localId === true ? "recep-yes" : "recep-no"
                }`}
                onClick={() => setLocalId(!localId)}
                disabled={!edit}
              >
                Yes
              </button>
              <button
                className={`cust-btn w-100 ${
                  localId === false ? "recep-yes" : "recep-no"
                }`}
                onClick={() => setLocalId(!localId)}
                disabled={!edit}
              >
                No
              </button>
            </div>
          </div>
        </div>

        {type !== 1 && (
          <div>
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Pricing Per Day
            </h4>
            <div className="">
              <table
                className="w-100 input-pop"
                style={{ borderCollapse: "inherit" }}
              >
                <thead className="mb-4">
                  <tr>
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                    <th>Sunday</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {[
                      "mon_price",
                      "tue_price",
                      "wed_price",
                      "thu_price",
                      "fri_price",
                      "sat_price",
                      "sun_price",
                    ].map((field, i) => (
                      <td key={i}>
                        {edit ? (
                          <input
                            type="number"
                            className="input-pop ps-2 w-100 my-4"
                            value={prices[0][field]}
                            onChange={(e) =>
                              handlePriceChange(field, e.target.value)
                            }
                          />
                        ) : (
                          <p className="input-pop mt-2">
                            {`Rs.${prices[0][field]}/-`}
                          </p>
                        )}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="d-flex flex-wrap gap-3 my-5">
              <div className="col-md-3 my-4">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Total Person Count
                </h4>
                <input
                  type="number"
                  className="input-pop ps-2 w-100 "
                  value={prices[0]?.total_persons}
                  onChange={(e) =>
                    handlePriceChange("total_persons", e.target.value)
                  }
                  disabled={!edit}
                />
              </div>
              <div className="col-md-3 my-4">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Extra Person Count
                </h4>
                <input
                  type="number"
                  className="input-pop ps-2 w-100 "
                  value={prices[0]?.additional_persons}
                  onChange={(e) =>
                    handlePriceChange("additional_persons", e.target.value)
                  }
                  disabled={!edit}
                />
              </div>
              <div className="col-md-3 my-4">
                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                  Extra Charges Per Person
                </h4>
                <input
                  type="number"
                  className="input-pop ps-2 w-100 "
                  value={prices[0]?.extra_charge_per_person}
                  onChange={(e) =>
                    handlePriceChange("extra_charge_per_person", e.target.value)
                  }
                  disabled={!edit}
                />
              </div>
            </div>
          </div>
        )}
        <div className="col-md-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Minimum Age
          </h4>
          <select
            className="input-pop ps-2 w-100"
            value={minAge}
            onChange={(e) => setMinAge(e.target.value)}
            disabled={!edit}
          >
            <option value={""}>Select Age Category</option>
            {ageList?.map((item, index) => (
              <option value={item?.id} key={index}>
                {item?.name}
              </option>
            ))}
          </select>
        </div>
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
          Location
        </h4>
        <div className="d-flex gap-3 ac-jb mt-3">
          <div className=" d-flex ac-js gap-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Country
            </h4>
            <SelectBoxImg
              array_list={countryList}
              value_text={country}
              setvalue_text={setCountry}
              placeholder_text="Select Country"
              isMulti={false}
              isTextArea={false}
              code={"code"}
              setValidation={setValidation}
              edit={!edit}
            />
          </div>
          <div className=" d-flex ac-js gap-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              State
            </h4>
            <SelectBoxImg
              array_list={stateList}
              value_text={state}
              setvalue_text={setState}
              placeholder_text="Select Country"
              isMulti={false}
              isTextArea={false}
              code={"code"}
              setValidation={setValidation}
              edit={!edit}
            />
          </div>
          <div className=" d-flex ac-js gap-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              City
            </h4>
            <SelectBoxImg
              array_list={cityList}
              value_text={city}
              setvalue_text={setCity}
              placeholder_text="Select Country"
              isMulti={false}
              isTextArea={false}
              code={"code"}
              setValidation={setValidation}
              edit={!edit}
            />
          </div>
          <div className=" d-flex ac-js gap-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Area
            </h4>
            <SelectBoxImg
              array_list={areaList}
              value_text={area}
              setvalue_text={setArea}
              placeholder_text="Select Country"
              isMulti={false}
              isTextArea={false}
              code={"code"}
              setValidation={setValidation}
              edit={!edit}
            />
          </div>
        </div>
        <div className="mt-5 ">
          <GoogleMapPages
            setLatitude={setLatitude}
            latitude={latitude}
            longitude={longitude}
            setLongitude={setLongitude}
            edit={edit}
          />
          <div className="d-flex justify-content-between mt-3">
            <div className="col-md-4">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Latitude
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                value={latitude}
                onChange={(e) => setLatitude(e.target.value)}
                placeholder="Enter Latitude"
                disabled
              />
            </div>
            <div className="col-md-4">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Longitude
              </h4>
              <input
                type="number"
                className="input-pop ps-2 w-100"
                value={longitude}
                onChange={(e) => setLongitude(e.target.value)}
                placeholder="Enter Longitude"
                disabled
              />
            </div>
          </div>
          <div className="w-100 mt-3">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Address
            </h4>
            <textarea
              className="input-pop ps-2 w-100"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              disabled={!edit}
              style={{ height: "100px" }}
            />
          </div>
        </div>
        <div className="d-flex ac-jb mb-2">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
            Description
          </h4>
          {edit && (
            <select
              onChange={(e) => {
                const selectedId = e.target.value;
                const selectedPolicy = optionsDesc.find(
                  (item) => item.id.toString() === selectedId
                );
                if (selectedPolicy) {
                  setDesc(selectedPolicy.description);
                }
              }}
              className="input-pop ps-2 mx-3 w-25"
            >
              <option value={""}>Select Policy</option>
              {optionsDesc.map((item, ind) => (
                <option key={ind} value={item?.id}>
                  {item.description.length > 32 ? (
                    `${stripHtml(item.description).substring(0, 32)}...`
                  ) : (
                    <p>{stripHtml(item.description)}</p>
                  )}
                </option>
              ))}
            </select>
          )}
        </div>

        <JoditEditor
          ref={editor}
          value={desc}
          onBlur={(e) => setDesc(e)} // Changed this line
          config={joditConfig}
        />
      </div>

      {/* Description Section */}
      <div className="mt-4">
        {/* Fixed Policies */}
        <div className="my-4">
          <div className="d-flex ac-jb mb-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              Cancellation Policy
            </h4>
            {edit && (
              <select
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedPolicy = optionsCancel.find(
                    (item) => item.id.toString() === selectedId
                  );
                  if (selectedPolicy) {
                    setCancellationPolicy(selectedPolicy.description);
                  }
                }}
                className="input-pop ps-2 mx-3 w-25"
              >
                <option value={""}>Select Policy</option>
                {optionsCancel.map((item, ind) => (
                  <option key={ind} value={item?.id}>
                    {item.description.length > 32 ? (
                      `${stripHtml(item.description).substring(0, 32)}...`
                    ) : (
                      <p>{stripHtml(item.description)}</p>
                    )}
                  </option>
                ))}
              </select>
            )}
          </div>
          <JoditEditor
            ref={editor}
            value={cancellationPolicy}
            onBlur={(e) => setCancellationPolicy(e)}
            config={joditConfig}
          />
        </div>

        <div className="my-4">
          <div className="d-flex ac-jb mb-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              House Rules
            </h4>
            {edit && (
              <select
                className="input-pop ps-2 mx-3 w-25"
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedPolicy = optionsRules.find(
                    (item) => item.id.toString() === selectedId
                  );
                  if (selectedPolicy) {
                    setHouseRules(selectedPolicy.description);
                  }
                }}
              >
                <option value={""}>Select Policy</option>
                {optionsRules.map((item, ind) => (
                  <option key={ind} value={item?.id}>
                    {item.description.length > 32 ? (
                      `${stripHtml(item.description).substring(0, 32)}...`
                    ) : (
                      <p>{stripHtml(item.description)}</p>
                    )}
                  </option>
                ))}
              </select>
            )}
          </div>
          <JoditEditor
            ref={houseRulesRef}
            value={houseRules}
            onBlur={(e) => setHouseRules(e)}
            config={joditConfig}
          />
        </div>

        <div className="my-4">
          <div className="d-flex ac-jb mb-2">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              Other Policies
            </h4>
            {edit && (
              <select
                className="input-pop ps-2 mx-3 w-25"
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedPolicy = optionsSafety.find(
                    (item) => item.id.toString() === selectedId
                  );
                  if (selectedPolicy) {
                    setSafetyProperty(selectedPolicy.description);
                  }
                }}
              >
                <option value={""}>Select Policy</option>
                {optionsSafety.map((item, ind) => (
                  <option key={ind} value={item?.id}>
                    {item.description.length > 32 ? (
                      `${stripHtml(item.description).substring(0, 32)}...`
                    ) : (
                      <p>{stripHtml(item.description)}</p>
                    )}
                  </option>
                ))}
              </select>
            )}
          </div>
          <JoditEditor
            ref={editor}
            value={safetyProperty}
            onBlur={(e) => setSafetyProperty(e)}
            config={joditConfig}
          />
        </div>

        <div className="mt-4">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
            Additional Details
          </h4>
        </div>

        {/* Additional Policies */}
        {additionalPolicies.map((policy, index) => (
          <div key={policy.id || index}>
            <div className="d-flex ac-jb">
              <input
                className="input-pop ps-2 w-30 my-3"
                value={policy.heading}
                onChange={(e) => {
                  const updated = [...additionalPolicies];
                  updated[index].heading = e.target.value;
                  setAdditionalPolicies(updated);
                }}
                disabled={!edit}
              />
              {edit ? (
                <IconButton
                  onClick={() => handleRemovePolicy(index)}
                  size="small"
                >
                  <CancelIcon fontSize="small" />
                </IconButton>
              ) : null}
            </div>
            <JoditEditor
              value={policy.content || ""}
              onBlur={(content) =>
                handleAdditionalContentChange(content, index, "value")
              }
              config={configJodit}
              ref={(el) => (editor.current[index] = el)}
            />
          </div>
        ))}

        {/* Add Button (only show if less than 3 additional policies) */}
        {additionalPolicies.length < 3 && edit && (
          <button className="cust-btn recep-yes mt-3" onClick={handleAddPolicy}>
            Add
          </button>
        )}

        {edit && (
          <div>
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
              Choose Images (Max 10)
            </h4>
            <div className="d-flex ac-js gap-3 flex-wrap">
              <div className="position-relative">
                <button
                  className="cust-btn recep-yes mt-3 mb-3"
                  onClick={() => imgRef.current?.click()}
                >
                  Upload
                </button>
                <input
                  type="file"
                  className="input-pop mt-2 w-100 d-none"
                  accept="image/*"
                  onChange={(e) => handleImageChange(e)}
                  multiple={true}
                  ref={imgRef}
                />
              </div>
            </div>
          </div>
        )}

        {/* Images Section with Drag and Drop */}
        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
          Property Images
        </h4>

        <div className="d-flex ac-js gap-3 flex-wrap">
          {draggableImages?.map((image, index) => (
            <div
              key={index}
              draggable
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDragEnd={handleDragEnd}
              style={{
                opacity: draggedItem === index ? 0.5 : 1,
                cursor: "move",
                position: "relative",
              }}
            >
              {/* Remove Icon (Shown only in edit mode) */}
              {edit && (
                <div
                  onClick={() => handleRemoveImage(index)}
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                >
                  <CancelIcon style={{ fontSize: "18px", color: "red" }} />
                </div>
              )}

              {/* Image */}
              <img
                onClick={() => handleImageClick(image.image)}
                src={
                  edit && image?.image instanceof File
                    ? URL.createObjectURL(image.image)
                    : image?.image
                }
                style={{
                  height: "100px",
                  width: "100px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  objectFit: "cover",
                }}
                alt={`Property image ${index + 1}`}
              />
            </div>
          ))}
        </div>

        <div className="d-flex ac-jb gap-3 flex-wrap">
          {reqOn?.created_at != null && (
            <div className="col-md-4 mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Property Requested On
              </h4>
              <input
                className="input-pop ps-2 w-100"
                value={moment(reqOn?.created_at).format("DD-MM-YYYY")}
                placeholder=""
                disabled
              />
            </div>
          )}

          {reqOn?.approved_on != null && (
            <div className="col-md-4 mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Property Approved On
              </h4>
              <input
                className="input-pop ps-2 w-100"
                value={moment(reqOn?.approved_on).format("DD-MM-YYYY")}
                placeholder=""
                disabled
              />
            </div>
          )}
          {reqOn?.approved_by != null && (
            <div className="col-md-4 mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Property Approved By
              </h4>
              <input
                className="input-pop ps-2 w-100"
                value={reqOn?.approved_by}
                placeholder=""
                disabled
              />
            </div>
          )}
          {reqOn?.rejected_on != null && (
            <div className="col-md-4 mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Property Rejected On
              </h4>
              <input
                className="input-pop ps-2 w-100"
                value={moment(reqOn?.rejected_on).format("DD-MM-YYYY")}
                placeholder=""
                disabled
              />
            </div>
          )}
          {reqOn?.rejected_by != null && (
            <div className="col-md-4 mt-3">
              <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                Property Rejected By
              </h4>
              <input
                className="input-pop ps-2 w-100"
                value={reqOn?.rejected_by?.username}
                placeholder=""
                disabled
              />
            </div>
          )}
        </div>

        {edit && (
          <div className="d-flex ac-je mt-5">
            <button
              className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
              onClick={() => handleEdit(id)}
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm"></div>
              ) : (
                "Submit"
              )}
            </button>
          </div>
        )}
        {/* Image Popup */}
        {popup && selectedImage && (
          <div className="img-popup-design">
            <div className="img-popup">
              <div
                className="d-flex ac-je pointer"
                onClick={() => setPopup(false)}
              >
                <CancelIcon />
              </div>
              <div
                style={{
                  width: "350px",
                  height: "350px",
                  overflow: "hidden",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "8px",
                  marginTop: "1rem",
                  backgroundColor: "#f8f8f8",
                }}
              >
                <img
                  src={
                    selectedImage instanceof File
                      ? URL.createObjectURL(selectedImage)
                      : selectedImage
                  }
                  alt="Selected"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(RejectedDetailsTab);
